import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { Tables } from "@stockuj/types";

export function useOrganization() {
  return useQuery({
    queryKey: ["organization"],
    queryFn: async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (!user) throw new Error("Not authenticated");

      const { data, error } = await supabase
        .from("organization_members")
        .select("organization_id, role, organizations(*)")
        .eq("user_id", user.id)
        .limit(1)
        .single();

      if (error) throw error;

      return {
        organizationId: data.organization_id,
        role: data.role as Tables<"organization_members">["role"],
        organization: data.organizations as unknown as Tables<"organizations">,
      };
    },
  });
}
